import "./career.css";

const LIFE_MOMENTS = [
  {
    image: "/images/career-hero-handshake.png",
    caption: "Team Collaborations",
  },
  {
    image: "/images/about-team-office.png",
    caption: "Learning Together",
  },
  {
    image: "/images/team/1.jpg",
    caption: "Celebrating Success",
  },
  {
    image: "/images/team/4.jpg",
    caption: "Giving Back",
  },
];

export default function CareerLife() {
  return (
    <section className="career-life">
      <div className="career-life-inner">
        <header className="career-section-head">
          <h2>Life at GPS Finvest</h2>
        </header>

        <div className="career-life-grid">
          <div className="career-life-copy">
            <p>
              We foster a positive, inclusive, and dynamic work environment
              where people are encouraged to think big, take ownership, and grow
              together.
            </p>
            <a href="#open-positions" className="career-life-btn">
              Explore Life At GPS Finvest
              <span aria-hidden="true">→</span>
            </a>
          </div>

          <div className="career-life-gallery">
            {LIFE_MOMENTS.map((item) => (
              <figure key={item.caption} className="career-life-card">
                <img src={item.image} alt={item.caption} />
                <figcaption>{item.caption}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
